<template>
	<div v-if="channels.length" class="w-full space-y-1">

		<input type="search" v-model="filter"
			   class="text-base border-0 block w-full p-1.5 px-3 mb-2 rounded placeholder:text-gray-300 !outline-none bg-white dark:placeholder:text-slate-600 dark:bg-slate-800/70 dark:text-white dark:focus:bg-slate-800"
			   placeholder="Поиск подсайтов">

		<div v-if="!filteredChannels.length" class="p-2 text-gray-500 text-sm">
			Подсайты не найдены
		</div>

		<div v-else>
			<div v-for="(element,index) in filteredChannels"
				 class="flex items-center space hover:bg-white/80 dark:hover:bg-slate-500/80 rounded"
				 :class="{'hidden': !opened && index > 4}">
				<a :href="element.url"
				   class="p-2 flex-1 flex items-center space-x-2 data-reset-scroll text-black dark:text-white mr-2">

					<div class="relative w-7 h-7">
						<avatar :ava="element.ava" :square="1" class="w-7 h-7 shrink-0"></avatar>
						<div v-if="element.subscribed" title="Вы подписаны на этот подсайт"
							 class="absolute -left-0.5 -top-0.5 w-2 h-2 rounded-full bg-green-500"></div>
					</div>

					<div class="flex-1 leading-none">
						<div class="text-sm">{{ element.name }}</div>
						<div class="text-xs opacity-30">
							{{ plural(element.subscribers_count, ['подписчик', 'подписчика', 'подписчиков']) }}
						</div>
					</div>
				</a>
			</div>

			<div @click="opened = !opened" v-if="filteredChannels.length > 5"
				 class="cursor-pointer p-2 text-gray-500 dark:text-slate-400 text-sm flex items-center space-x-2">
				<div>
					<svg
						:class="{'rotate-180': opened}"
						class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
						viewBox="0 0 16 16">
						<path fill-rule="evenodd"
							  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
					</svg>
				</div>
				<div v-if="opened">Свернуть</div>
				<div v-else>Еще {{ filteredChannels.length - 5 }}</div>
			</div>

		</div>
	</div>
</template>
<script>
import plural from "../../js/modules/Plural";
import KeyboardLayout from "../../js/modules/KeyboardLayout";
import Avatar from "./Avatar.vue";
import Client from "../../js/modules/Client";

export default {
	components: {Avatar},
	props: [
		'blocked',
		'subscribed',
	],
	data() {
		return {
			filter: '',
			channels: [],
			opened: false,
		};
	},
	mounted() {
		this.loadChannels();
	},
	methods: {
		loadChannels() {
			Client.get('/api/v1.1/channel/list?conditions[]=visibleOnly&conditions[]=withSubscribed&conditions[]=withSubscribersCount')
				.then(response => {
					this.channels = response.data.data;
				})
				.catch(e => {
					console.log(e);
				})
		},
		plural(count, words) {
			return plural(count, words);
		},
	},
	computed: {
		filteredChannels() {
			return this.channels.filter(item => {
				let filter = this.filter.trim().toLowerCase();
				if (filter) {
					let translated = KeyboardLayout.switch(filter);
					return item.name.trim().toLowerCase().search(filter) !== -1
						|| item.name.trim().toLowerCase().search(translated) !== -1;
				}
				return true;
			}).sort((a, b) => {
				if (a.subscribed && !b.subscribed) {
					return -1;
				}
				if (!a.subscribed && b.subscribed) {
					return 1;
				}
				return 0;
			})
		}
	}

}
</script>
